const obj = {
  server: {
    api: "https://api-qa.warriortrading.com/api",
    stock: "https://scan-qa.warriortrading.com",
    identity: "https://identity-qa.warriortrading.com/security",
    chatroom: "https://chatroom-qa.warriortrading.com",
    sim: "https://sim-qa.warriortrading.com",
  },
  scannerServers: [
    {
      name: "scan-dev",
      value: "https://scan-dev.warriortrading.com",
      down: "",
      up: "",
    },
    {
      name: "scan-qa",
      value: "https://scan-qa.warriortrading.com",
      down: "https://scan-qa.warriortrading.com/ops-api/v1/down-hpas",
      up: "https://scan-qa.warriortrading.com/ops-api/v1/up-hpas",
    },
    {
      name: "scan-prod",
      value: "https://scan-prod.warriortrading.com",
      down: "",
      up: "",
    },
  ],
};

export default obj;
